var virtualEntryIdName = `one-entry`;
var virtualEntryId = `virtual:${virtualEntryIdName}`;
var virtalEntryIdClient = `/@id/__x00__virtual:${virtualEntryIdName}`;
var resolvedVirtualEntryId = "\0" + virtualEntryId;
var virtualEntryIdNativeName = `${virtualEntryIdName}-native`;
var virtualEntryIdNative = `virtual:${virtualEntryIdNativeName}`;
var resolvedVirtualEntryIdNative = "\0" + virtualEntryIdNativeName;
export {
  resolvedVirtualEntryId,
  resolvedVirtualEntryIdNative,
  virtalEntryIdClient,
  virtualEntryId,
  virtualEntryIdName,
  virtualEntryIdNative
};
//# sourceMappingURL=virtualEntryConstants.js.map
